var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-layout-footer',[_c('a-row',{attrs:{"type":"flex"}},[_c('a-col',{attrs:{"span":24,"md":12}},[_c('p',{staticClass:"copyright"},[_vm._v(" © "+_vm._s(_vm.currentYear)+" Aegis-神盾　为出海业务保驾护航 ")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }